export default __webpack_public_path__ + "static/media/plataformasplesk.af4dda86.jpg";